export enum CurrencyName {
  USD = 'USD',
  EUR = 'EUR',
}
export enum CurrencySymbol {
  USD = '$',
  EUR = '€',
}
